import SitesListPageContainer from './containers/SiteListPageContainer'

export default SitesListPageContainer
